import request from '@/utils/request'

// 数据库管理--执行备份
export const startBackup = (data) => {
    return request({
        url: '/db/backup/manage',
        method: 'POST',
        data
    })
}

// 数据库管理--备份列表
export const getBackupLists = (data) => {
    return request({
        url: '/db/backup/lists',
        params: data
    })
}

// 删除备份
export const delBackup = (data) => {
    return request({
        url: '/db/backup/manage',
        method: 'DELETE',
        data
    })
}

// 数据库管理--恢复备份
export const restoreBackup = (data) => {
    return request({
        url: '/db/backup/restore',
        method: 'POST',
        data
    })
}
